<template>
    <div :class="{'mx-auto max-w-7xl sm:px-6 lg:px-8': !noPaddingX}">
        <div :class="{'overflow-x-auto': scrollX}" class="overflow-hidden bg-white shadow-sm sm:rounded-lg">
            <div class="text-gray-900">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        noPaddingX: {
            type: Boolean,
            default: false
        },
        scrollX: {
            type: Boolean,
            default: false
        }
    }
}
</script>